<template>
  <form @submit.prevent="submitForm">
    <!-- Información Básica -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="Clave"
          label="Clave"
          type="text"
          v-model="formData.Clave"
          :required="true"
          :maxlength="50"
          :disabled="isEditing"
          helpText="Código único de la unidad de medida"
        />
      </div>
      <div class="col-md-6">
        <!-- Campo EmpresaId oculto - se captura automáticamente -->
        <input type="hidden" v-model="formData.EmpresaId" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <FormField
          id="Nombre"
          label="Nombre"
          type="text"
          v-model="formData.Nombre"
          :required="true"
          :maxlength="100"
          helpText="Nombre de la unidad de medida"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="ClaveErp"
          label="Clave ERP"
          type="text"
          v-model="formData.ClaveErp"
          :maxlength="50"
          helpText="Clave en el sistema ERP"
        />
      </div>
    </div>

    <!-- Descripción y Tipo -->
    <div class="row">
      <div class="col-md-8">
        <FormField
          id="Descripcion"
          label="Descripción"
          type="text"
          v-model="formData.Descripcion"
          :maxlength="200"
          helpText="Descripción detallada de la unidad de medida"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="Tipo"
          label="Tipo"
          type="text"
          v-model="formData.Tipo"
          :maxlength="50"
          helpText="Tipo de unidad de medida"
        />
      </div>
    </div>

    <!-- Información SAT -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="ClaveSAT"
          label="Clave SAT"
          type="text"
          v-model="formData.ClaveSAT"
          :maxlength="20"
          helpText="Clave del SAT para la unidad de medida"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="NombreSAT"
          label="Nombre SAT"
          type="text"
          v-model="formData.NombreSAT"
          :maxlength="100"
          helpText="Nombre según el SAT"
        />
      </div>
    </div>

    <!-- Orden y Estado -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="Orden"
          label="Orden"
          type="number"
          v-model="formData.Orden"
          :min="0"
          helpText="Orden de visualización"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="EsActivo"
          label="Estado"
          type="checkbox"
          v-model="formData.EsActivo"
          checkboxLabel="Unidad de medida activa"
          helpText="Indica si la unidad de medida está activa en el sistema"
        />
      </div>
    </div>

    <!-- Notas -->
    <div class="row">
      <div class="col-md-12">
        <FormField
          id="Notas"
          label="Notas"
          type="textarea"
          v-model="formData.Notas"
          :maxlength="500"
          helpText="Notas adicionales"
        />
      </div>
    </div>
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatUMedidaForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    unidadMedida: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: 1,
        Nombre: '',
        ClaveErp: '',
        EsActivo: true,
        Descripcion: '',
        Tipo: '',
        ClaveSAT: '',
        NombreSAT: '',
        Orden: 0,
        Notas: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.unidadMedida }
    };
  },
  watch: {
    unidadMedida: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
